import { IContextWrapper } from '@vivli/shared/infrastructure/interface';
export const NoLayoutWrapper = ({ children }: IContextWrapper) => {
    return children;
};
